export const noticeCodes = [
    "GENESYS#0001",
    "GENESYS#0002",
    "GENESYS#0003",
    "GENESYS#0004",
    "GENESYS_CLOSE_BY_USER#0001",
    "FOREGROUND_CONVERSATION#0001",
    "FOREGROUND_CONVERSATION#0002" // Conversazione già presente nella lista
];
